import React from "react";
import "./vikas.css";

const VikasKame = () => {
  const works = [
    {
      title: "✅ पाणीपुरवठा योजना सुधारणा",
      desc: "गावातील पाण्याची समस्या सोडवण्यासाठी नवीन नळ लाईन आणि टाकी दुरुस्तीचे काम पूर्ण.",
      year: "2024-25",
    },
    {
      title: "✅ रस्ते काँक्रिटीकरण",
      desc: "मुख्य रस्ते तसेच अंतर्गत गल्ली रस्त्यांचे सीसी (CC) रोड बांधकाम पूर्ण.",
      year: "2023-24",
    },
    {
      title: "✅ ग्रामपंचायत इमारत देखभाल",
      desc: "ग्रामपंचायत कार्यालयाचे नूतनीकरण, रंगकाम, वीजयोजना अपग्रेडेशन.",
      year: "2024",
    },
    {
      title: "✅ LED स्ट्रीट लाइट बसविणे",
      desc: "पर्यावरणपूरक LED लाईट्स बसवून ऊर्जा बचत वाढवली.",
      year: "2023",
    },
    {
      title: "✅ जलसंधारण कामे",
      desc: "पाणी आडवा-पाणी जिरवा या योजनेअंतर्गत छोटा बंधारा, गाळ काढणे, नाल्यांची साफसफाई.",
      year: "2022-23",
    },
    {
      title: "✅ स्वच्छता अभियान",
      desc: "स्वच्छ भारत मिशन अंतर्गत गावातील सार्वजनिक ठिकाणांची स्वच्छता आणि जागरूकता मोहीम.",
      year: "2024",
    }
  ];

  return (
    <div className="vikas-container">
      <h2 className="vikas-title">🏗️ विकास कामे (Development Works)</h2>

      <div className="vikas-grid">
        {works.map((work, index) => (
          <div className="vikas-card" key={index}>
            <h3 className="work-title">{work.title}</h3>
            <p className="work-desc">{work.desc}</p>
            <p className="work-year">📅 वर्ष : {work.year}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default VikasKame;
